import illustration from '../../../../shared/assets/empty-illustration.svg'
import { Link } from 'react-router-dom'
import React from 'react'
import { StubContactLinks } from '../../../../lib/widgets/stubs/StubContactLinks'

interface TabBrandMentionsStubProps {
  project?: string
}

export const TabBrandMentionsStub = ({ project }: TabBrandMentionsStubProps) => {
  return (
    <div className={'flex justify-center'}>
      <div className={'flex w-full max-w-[320px] flex-col items-center gap-[24px]'}>
        <div className={'w-full'}>
          <img alt={'Illustration'} className={'mx-auto max-w-full'} src={illustration} />
        </div>
        <div className={'flex w-full flex-col gap-[24px]'}>
          <div className={'flex w-full flex-col gap-[16px]'}>
            <div className={'flex flex-col items-center'}>
              <h2 className={'text-center text-[24px]'}>No data</h2>
              <p className={'text-center text-[15px] text-[#8E7CA7]'}>
                There are two likely reasons:
              </p>
            </div>
            <div
              className={'flex w-full flex-col gap-[16px] rounded-[16px] bg-focus/[0.06] p-[16px]'}
            >
              <ul className={'list list-disc pl-[16px] text-left text-focus-500'}>
                <li className={'pb-[12px]'}>
                  There are no ads mentioning the brand in the{' '}
                  <Link className={'text-default'} to={`/projects/${project}/locations`}>
                    countries
                  </Link>{' '}
                  selected for this project
                </li>
                <li>
                  The{' '}
                  <Link className={'text-default'} to={`/projects/${project}/general`}>
                    brand names
                  </Link>{' '}
                  entered are incorrect or irrelevant
                </li>
              </ul>
            </div>
          </div>
          <div className={'flex flex-col items-center justify-center gap-[8px]'}>
            <p className={'max-w-[254px] text-center text-[13px] leading-[18px] text-[#8E7CA7]'}>
              💡 A tip: try adding keywords with common misspellings of your brand. Here&apos;s an
              example for &quot;Bluepear&quot;:
            </p>
            <div className={'flex gap-[4px] text-[13px] text-[#8E7CA7]'}>
              <div className={'rounded-[8px] bg-focus/[0.06] p-[8px]'}>
                <p className={'leading-none'}>Blue Pear</p>
              </div>
              <div className={'rounded-[8px] bg-focus/[0.06] p-[8px]'}>
                <p className={'leading-none'}>Blupear</p>
              </div>
              <div className={'rounded-[8px] bg-focus/[0.06] p-[8px]'}>
                <p className={'leading-none'}>Blueper</p>
              </div>
            </div>
          </div>
        </div>
        <div className={'flex flex-col gap-[8px]'}>
          <p className={'text-center text-[15px] text-[#8E7CA7]'}>Contact us for help</p>
          <StubContactLinks />
        </div>
      </div>
    </div>
  )
}
